
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/for-cic/undone",
      function () {
        return require("private-next-pages/admin/for-cic/undone.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/for-cic/undone"])
      });
    }
  